"use client";

import type { ComponentPropsWithoutRef } from "react";

const HASH_RE = /^#/;

export function ScrollLink({
  href,
  children,
  onClick,
  ...props
}: ComponentPropsWithoutRef<"a"> & { href: string }) {
  const id = href.replace(HASH_RE, "");
  return (
    <a
      href={href}
      onClick={(e) => {
        e.preventDefault();
        onClick?.(e);
        document
          .getElementById(id)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }}
      {...props}
    >
      {children}
    </a>
  );
}
